import { Container, Divider, Typography, Grid2, useMediaQuery  } from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import badnorth from './screenshots/badnorth.png'
import islandstrains from './screenshots/islandstrains.jpg'
import UI from './screenshots/UI.png';
import newsettlement from './screenshots/newsettlement.gif'
import buildroads from './screenshots/buildroads.gif'
import routing from './screenshots/routing.gif';
import defend from './screenshots/defend.gif';
import disaster from './screenshots/disaster.gif';
import twod from './screenshots/2d.webp';
import shader from './screenshots/shader.png';
import threed from './screenshots/3d2.png';
import mockup from './screenshots/mockup.png';
import { Helmet } from 'react-helmet';

const theme = createTheme({
  palette: {
    primary: {
      main: '#ff9727',
      contrastText: 'white',
    },
  },
});

const Surge = () => {
    const isMob = useMediaQuery('(max-width:1000px)');

    return <ThemeProvider theme={theme}>
        <Helmet>
            <title>More Bread Please - YZee Games</title>
            <meta name="description" content="Your kingdom teeters on the edge of disaster - only your trade routes can save it. More Bread Please is a thoughtful medieval strategy game about designing efficient trade routes to keep chaos at bay and your people fed. Not by conquest, but by connection." />
        </Helmet>
        <Container maxWidth="md">

            <Container sx={{paddingBottom:15, paddingTop:15}}>


            <Divider color='white'/>
            <Grid2 container justifyContent={'center'} alignItems={'center'}>
                <Typography align='center' fontFamily={'Metamorphous'} sx={{fontSize: 55, maxWidth:'md'}} color='white'>More Bread Please!</Typography>
            </Grid2>
            <Divider color='white' sx={{marginBottom: 3}}/>

                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                    <iframe
                        allowFullScreen
                        title="trailer"
                        style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        }}
                        src="https://www.youtube.com/embed/UVvBF8q6zEE"
                    ></iframe>
                </div>
        
            <Typography align='center' fontFamily={'Patrick Hand'} sx={{fontSize: 26, marginTop: 3}} color='white'>Your kingdom teeters on the edge of disaster - only your trade routes can save it. More Bread Please is a thoughtful medieval strategy game about designing efficient trade routes to keep chaos at bay and your people fed. Not by conquest, but by connection.</Typography>
            
        </Container>
    </Container>

        <Container sx={{backgroundColor:'white', minWidth:'100%'}}>
            <Container maxWidth="md" sx={{paddingBottom:25, paddingTop:15}}>





            <Grid2 container justifyContent={'center'} alignItems={'center'}>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize:isMob ? 36.5 : 46.5, mb:1}} color='#463c30'>Gameplay Footage</Typography>
            </Grid2>

                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                    <iframe
                        allowFullScreen
                        title="trailer"
                        style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        }}
                        src="https://www.youtube.com/embed/l82xndA5LE0"
                    ></iframe>
                </div>

    </Container>
    </Container>


<Container sx={{minWidth:'100%', paddingBottom:25, paddingTop:15}}>
        <Container maxWidth="md">
            <Grid2 container direction={'column'} alignItems={'left'}>
                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'white'}}>Features</Typography>
                </Grid2>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 36.5, color:'white', mt:3}} color='#463c30'>🗺️ Route Based Logistics</Typography>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white', mb:2}}>
                    <li>Draw trade routes using wagons on land and ships on water</li>
                    <li>Transport essential resources like food, wood, stone, and gold</li>
                    <li>Optimise delivery networks to prevent starvation</li>
                </Typography>
                <img alt={"screenshot1"} src={routing} style={{width:'100%', marginBottom:30}}></img>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 36.5, color:'white', mt:3}} color='#463c30'>🛠️ Build & Connect</Typography>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white', mb:2}}>
                    <li>Construct roads, bridges, and forts</li>
                    <li>Upgrade infrastructure to boost efficiency and defense</li>
                    <li>Every few turns welcome new settlements into your trade network - each offering a key resource</li>
                </Typography>
                <img alt={"screenshot1"} src={newsettlement} style={{width:'100%', marginBottom:20}}></img>
                <img alt={"screenshot1"} src={buildroads} style={{width:'100%', marginBottom:30}}></img>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 36.5, color:'white', mt:3}} color='#463c30'>⚔️ Defend Your Network</Typography>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white', mb:2}}>
                    <li>React to barbarian invasions by positioning battalions and building forts</li>
                    <li>Battle resolution is turn-based and visible, adding strategic tension</li>
                    <li>Protect food routes or risk starvation and loss</li>
                </Typography>
                <img alt={"screenshot1"} src={defend} style={{width:'100%', marginBottom:30}}></img>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 36.5, color:'white', mt:3}} color='#463c30'>🌊 Disaster & Environment Adaptation</Typography>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white', mb:2}}>
                    <li>Survive floods and earthquakes that destroy settlements and break supply lines</li>
                    <li>Reroute and rebuild before your settlements starve</li>
                    <li>Each map presents a new geographic and resource puzzle, challenging you to navigate and adapt to rivers, waterfalls, cliffs, deserts, hills, and mountains</li>
                </Typography>
                <img alt={"screenshot1"} src={disaster} style={{width:'100%', marginBottom:30}}></img>

            </Grid2>
        </Container>
    </Container>





    <Container sx={{minWidth:'100%', paddingBottom:25, paddingTop:15, backgroundColor:'white'}}>
        <Container maxWidth="md">
            <Grid2 container direction={'column'} alignItems={'left'}>
                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'#463c30'}}>Art & Aesthetic</Typography>
                </Grid2>

                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30', marginTop:3}}>
                    <li>Low-poly 3D art inspired by Bad North and similar looking games</li>
                    <li>Simple textures with stylised models</li>
                    <li>Stylised and readable - clear strategy visuals</li>
                    <li>UI is minimal and readable with an elegant medieval feel</li>
                    <li>Variety in terrain and environment</li>
                </Typography>

                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 36.5, color:'#463c30', marginTop:5}}>Why The Art Style?</Typography>
                </Grid2>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30', textAlign: 'left'}}>
                    <li>UI contrast and style consistency</li>
                    <li>Simplicity improves readability - e.g. too many tile variations making tile types harder to recognise, textures adding unnecessary clutter</li>
                    <li>Strategy relies on quickly identifying important elements</li>
                    <li>Faster to produce and iterate on, making it ideal for a small team</li>
                    <li>Stylised visuals offer strong artistic impact without the heavy workload of realism</li>
                </Typography>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 27.5, color:'#463c30', marginTop:5}}>Current in-engine visual mockup (work in progress)</Typography>
                <img alt={"screenshot1"} src={mockup} style={{width:'100%'}}></img>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 27.5, color:'#463c30', marginTop:3}}>Bad North</Typography>
                <img alt={"screenshot2"} src={badnorth} style={{width:'100%'}}></img>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 27.5, color:'#463c30', marginTop:3}}>Islands and Trains</Typography>
                <img alt={"screenshot3"} src={islandstrains} style={{width:'100%'}}></img>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 27.5, color:'#463c30', marginTop:3}}>UI Design</Typography>
                <img alt={"screenshot4"} src={UI} style={{width:'100%'}}></img>

            </Grid2>
        </Container>
    </Container>




    <Container sx={{minWidth:'100%', paddingBottom:25, paddingTop:15}}>
        <Container maxWidth="md">
            <Grid2 container direction={'column'} alignItems={'left'}>

                            <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'white'}}>Sound & Atmosphere</Typography>
                </Grid2>

                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white', marginTop:3}}>
                    <li>A calm medieval atmosphere with moments of tension: nature sounds, peasant voices, wheels creaking, ambient disasters</li>
                    <li>Medieval themed soundtrack drawing from cultures during the middle ages</li>
                    <li>Sound reinforces gameplay states (danger, scarcity, relief)</li>
                    <li>Needs to evoke togetherness and unity - everything connected</li>
                </Typography>

                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', marginTop:30 }}>
                    <iframe
                        allowFullScreen
                        title="trailer"
                        style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        }}
                        src="https://www.youtube.com/embed/GGfttSfGbBM?start=56&autoplay=1&rel=0"
                    ></iframe>
                </div>
                
                                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', marginTop:30 }}>
                    <iframe
                        allowFullScreen
                        title="trailer"
                        style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        }}
                        src="https://www.youtube.com/embed/K7ZqZVunCb4?start=147&autoplay=1&rel=0"
                    ></iframe>
                </div>

                                                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', marginTop:30 }}>
                    <iframe
                        allowFullScreen
                        title="trailer"
                        style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        }}
                        src="https://www.youtube.com/embed/HVw_1RZncec?start=59&autoplay=1&rel=0"
                    ></iframe>
                </div>


                                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', marginTop:30 }}>
                    <iframe
                        allowFullScreen
                        title="trailer"
                        style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        }}
                        src="https://www.youtube.com/embed/OxMQjlBq6zQ?start=6228&autoplay=1&rel=0"
                    ></iframe>
                </div>

            </Grid2>
        </Container>
    </Container>

    
    <Container sx={{minWidth:'100%', paddingBottom:25, paddingTop:15, backgroundColor:'white'}}>
        <Container maxWidth="md">
            <Grid2 container direction={'column'} alignItems={'left'}>
                                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'#463c30'}}>Diversity & Community Impact</Typography>
                </Grid2>

                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30'}}>
                    <li>Collaborating with charity Space2b to upskill migrant and refugee creatives and provide them with opportunities for visibility and professional growth</li>
                    <li>An emphasis on a multicultural team brings varied perspectives to development</li>
                    <li>UI and gameplay designed to be intuitive and inclusive, with features supporting players of all abilities</li>
                    <li>Character customiser supports all genders, skin tones, and cultures allowing everyone to feel represented</li>
                    <li>Fortified structures and soundtrack reflect global influences - not just classic Western medieval styles which is seen so often</li>
                </Typography>
                

                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'#463c30', marginTop:8}}>Progress</Typography>
                </Grid2>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30'}}>
                    <li>Development started Jan 6, 2024</li>
                    <li>Core systems and gameplay loop are in place</li>
                    <li>Art and audio direction locked in</li>
                    <li>UI is nearly complete</li>
                    <li>Informal playtesting ongoing with friends and family</li>
                </Typography>

                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'#463c30', marginTop:8}}>What's Changed Since Last Time</Typography>
                </Grid2>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30'}}>
<li>Extensive industry feedback incorporated from Brad Giblin, Mark Flanagan, and previous successful applicants - Rory Hulme (HappyHead), James Thomas (Barrel Smash), Matthew Jackson (Toot Games), and Oscar Brittain</li>
                    <li>Polished 3D mockup establishing a clear, achievable final visual target, reducing risk around the transition to 3D</li>
                    <li>Detailed technical breakdown explaining how the stylised art direction keeps 3D scope manageable and efficient</li>
                    <li>Accessibility consultant engaged (Jacqueline Arbuthnot) to advise on inclusive design and playtesting</li>
                    <li>PR and marketing support confirmed (The IndiEXP), alongside a more developed marketing and audience building plan, including a curated list of relevant press and YouTubers informed by VicScreen feedback</li>
                    <li>Budget refined with more realistic, better justified line items</li>
                    <li>Major development map improvements, including clearer 3D transition phases, expanded QA and playtesting schedule, and clearer project team roles and responsibilities</li>
                </Typography>

                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'#463c30', marginTop:8}}>Funding Goals</Typography>
                </Grid2>

                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30', textAlign: 'left'}}>
                    <li>Core Development Completion - finalising gameplay systems, refining balance and pacing, polishing visuals, and conversion to 3d</li>
                    <li>Diversity Initiatives - enabling inclusive character customisation and varied cultural content</li>
                    <li>Accessibility & Localisation - ensuring the game is playable by a broad audience across regions</li>
                    <li>QA & Playtesting - improving stability, bug fixes, and overall user experience</li>
                    <li>Steam Release & Publishing - packaging, optimising, and distributing the game for launch</li>
                    <li>Marketing & Outreach - raising awareness and engaging the strategy gaming community</li>
                </Typography>


            </Grid2>
        </Container>
    </Container>



    <Container sx={{minWidth:'100%', paddingBottom:25, paddingTop:15}}>
        <Container maxWidth="md">
            <Grid2 container direction={'column'} alignItems={'left'}>
                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'white', marginTop:8}}>Design Philosophy</Typography>
                </Grid2>

                <Typography
                fontFamily="Patrick Hand"
                sx={{ fontSize: 27.5, color: 'white', textAlign: 'left' }}
                >
                Our design philosophy focuses on accessibility, creating a strategy game that’s easy to pick up in a genre often seen as complex. Many games rely on dense HUDs and highly detailed worlds that, while immersive, make gameplay harder to read.<br /><br />
                We’re taking a simplified, stylised approach with clear UI, readable tiles, and low poly art. This not only enhances clarity but also reduces development time and cost. By prioritising simplicity over realism, we can maintain a strong visual identity, keep scope manageable for our small team, and stay true to our design principles.
                </Typography>


            </Grid2>
        </Container>
    </Container>


    <Container sx={{minWidth:'100%', paddingBottom:25, paddingTop:15, backgroundColor:'white'}}>
        <Container maxWidth="md">
            <Grid2 container direction={'column'} alignItems={'left'}>



                <Typography fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30', textAlign: 'left'}}>
                As mentioned in the grant, the game will be transitioning from a 2D world to a 3D one. While this may seem like a large task for a small team, the following section outlines the reasons behind the shift and how the workload will be effectively managed.
                
                </Typography>

                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'#463c30', marginTop:8}}>Why The Shift To 3D?</Typography>
                </Grid2>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30', textAlign: 'left'}}>
                    <li>2D pixel art didn’t match the existing UI - experimentation showed a stylised, simple colour approach works best</li>
                    <li>UI elements can be bigger and closer in 3D, as overlapping elements can be seen by adjusting the perspective</li>
                    <li>Watching deliveries and resources move in 3D feels more immersive, bringing the medieval world to life compared to a flat 2D view</li>
                    <li>3D enables richer aesthetics through lighting, shadows, shaders, and post-processing</li>
                    <li>Transitioning to 3D was the clear choice for both visual clarity and player experience</li>
                </Typography>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 27.5, color:'#463c30', marginTop:3}}>2D attempt - flat and visually limiting</Typography>
                <img alt={"2dAttempt"} src={twod} style={{width:'100%'}}></img>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 27.5, color:'#463c30', marginTop:3}}>Simple low poly 3D - clear, readable, and appealing (asset pack mockup)</Typography>
                <img alt={"3dAttempt"} src={threed} style={{width:'100%'}}></img>

                                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'#463c30', marginTop:8}}>Streamlined 3D Development</Typography>
                </Grid2>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30', textAlign: 'left'}}>
                    <li>Low poly models are faster to create and easier to manage</li>
                    <li>Minimal texturing and reliance on simple colours or gradients drastically reduce development time</li>
                    <li>Less tile types and tile variation reduce workload</li>
                    <li>Stylised visuals reduce the need for complex realistic lighting, shaders, and models, allowing clever shortcuts to achieve visual impact efficiently (e.g. flipping a model with different colouring for a water reflection)</li>
                    <li>Core game logic remains unchanged in 3D (mostly visual), so programming load is minimal - only small additions like billboards or wagon vertical movement are needed</li>
                    <li>Asset packs and Unity tools where necessary</li>
                    <li>Shaders, ambient occlusion, lighting, and light post-processing do the heavy visual lifting, supported by existing tools to simplify implementation</li>
                </Typography>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 27.5, color:'#463c30', marginTop:3}}>Flat Kit Water Shader</Typography>
                <img alt={"2dAttempt"} src={shader} style={{width:'100%'}}></img>

                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'#463c30', marginTop:8}}>Optimised Character Creator</Typography>
                </Grid2>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30', textAlign: 'left'}}>
                    <li>The stylised art style reduces the need for hyper realistic detail</li>
                    <li>All components are created in grayscale, allowing Unity to handle colour, placement, and layering, significantly reducing artist workload</li>
                    <li>Overlay textures function as dynamic masks, enabling a wide range of clothing customisation with minimal assets</li>
                    <li>Additional complexity is introduced with a small number of accessories like belts, hats, or scarves</li>
                    <li>Even with a small set of base drawings, the system can generate thousands of unique character combinations, demonstrating efficient asset reuse</li>
                </Typography>

                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'#463c30', marginTop:8}}>Achieving Variety Efficiently</Typography>
                </Grid2>
                <Typography fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30', textAlign: 'left', marginBottom:1}}>
                The castles and varied medieval environments will represent the bulk of the modelling effort, as most other assets such as hex tiles, vegetation, and terrain are relatively lightweight. However, this workload is manageable, and the scope is reduced for the following reasons:

                </Typography>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30', textAlign: 'left'}}>
                    <li>Subtle, low cost adjustments to lighting, water colour, and terrain allow for diverse regional aesthetics without major asset changes</li>
                    <li>The low poly, minimal texture style dramatically simplifies modelling - fewer UVs, no high detail sculpting, and minimal geometry to manage</li>
                    <li>Many castle designs share core structural elements like towers, walls, and gates, allowing modular reuse to efficiently create varied cultural styles</li>
                    <li>The distant camera view and non realistic style minimise the demand for intricate detail</li>
                </Typography>

            </Grid2>
        </Container>
    </Container>

    <Container sx={{minWidth:'100%', paddingBottom:25, paddingTop:15}}>
        <Container maxWidth="md">
            <Grid2 container direction={'column'} alignItems={'left'}>
                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'white', marginTop:8}}>How Funding Gets Us There</Typography>
                </Grid2>

                <Typography
                fontFamily="Patrick Hand"
                sx={{ fontSize: 27.5, color: 'white', textAlign: 'left' }}
                >
                Our streamlined approach means funding has an outsized impact. The low poly, minimal texture art style and modular asset design keep costs low and development efficient, allowing every dollar to go further. Support helps us focus on what matters most - refining gameplay systems, balancing progression and pacing, and adding the layers of polish for a full Steam release. With this efficiency, funding directly accelerates our transition to 3D and ensures “More Bread Please” reaches players as a complete, accessible, and high quality strategy experience. This project more importantly serves as a unique platform and oppurtunity for a team of new and emerging creatives from diverse cultural and professional backgrounds to collaborate, grow, and showcase our skills.
                </Typography>


            </Grid2>
        </Container>
    </Container>

  </ThemeProvider>
}

export default Surge;